enum BusinessBranchStatus {
    None = 0,
    Active = 1,
    Inactive = 2,
    Deleted = 3,
    Draft = 4,
    Abandoned = 5,
    Express = 6,
    WantingCancel = 7,
    Cancelled = 8,
    Lapsed = 9,
    AdminAccount = 10
}

export default BusinessBranchStatus
